/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: 照片筛选标签组件
 * @LastEditors: yingongjing
 * @LastEditTime: 2025-12-11 10:00:00
 */

import React from 'react'
import { PhotoItem } from '../../context/WatermarkBatchContext'
import './FilterTabs.scss'

// 定义筛选类型
export type FilterType = 'all' | 'unedited' | 'edited' | 'failed'

interface FilterTabsProps {
  filterType: FilterType
  onFilterChange: (type: FilterType) => void
  allCount: number
  uneditedCount: number
  editedCount: number
  failedCount: number
  // 埋点相关参数
  onTrack?: (params: {
    pageType: 'allPhoto' | 'notEdit' | 'edited' | 'failEdit'
    watermarkCnt?: number
    allPhotoCount?: number
    uneditedCount?: number
    editedCount?: number
    failedExtractionCount?: number
    photoNum?: number
    WatermarkID?: string
  }) => void
  watermarkCnt?: number
  allPhotoCount?: number
  failedExtractionCount?: number
  currentPhoto?: PhotoItem | null
}

const FilterTabs: React.FC<FilterTabsProps> = ({
  filterType,
  onFilterChange,
  allCount,
  uneditedCount,
  editedCount,
  failedCount,
  onTrack,
  watermarkCnt,
  allPhotoCount,
  uneditedCount: uneditedCountForTrack,
  failedExtractionCount,
  currentPhoto
}) => {
  const handleFilterClick = (
    type: FilterType,
    pageType: 'allPhoto' | 'notEdit' | 'edited' | 'failEdit'
  ) => {
    onFilterChange(type)

    // 埋点：切换页面类型
    if (onTrack) {
      onTrack({
        pageType,
        watermarkCnt,
        allPhotoCount,
        uneditedCount: uneditedCountForTrack,
        editedCount,
        failedExtractionCount,
        photoNum: allPhotoCount,
        WatermarkID: currentPhoto?.watermarkID
      })
    }
  }

  return (
    <div className="filter-tabs">
      <div
        className={`tab ${filterType === 'all' ? 'active' : ''}`}
        onClick={() => handleFilterClick('all', 'allPhoto')}
      >
        全部({allCount})
      </div>
      <div
        className={`tab ${filterType === 'unedited' ? 'active' : ''}`}
        onClick={() => handleFilterClick('unedited', 'notEdit')}
      >
        未编辑({uneditedCount})
      </div>
      <div
        className={`tab ${filterType === 'edited' ? 'active' : ''}`}
        onClick={() => handleFilterClick('edited', 'edited')}
      >
        已编辑({editedCount})
      </div>
      <div
        className={`tab ${filterType === 'failed' ? 'active' : ''}`}
        onClick={() => handleFilterClick('failed', 'failEdit')}
      >
        异常({failedCount})
      </div>
    </div>
  )
}

export default FilterTabs
